import { render } from "./add-kategori.vue?vue&type=template&id=31253cec&scoped=true"
import script from "./add-kategori.vue?vue&type=script&lang=js"
export * from "./add-kategori.vue?vue&type=script&lang=js"

import "./add-kategori.vue?vue&type=style&index=0&id=31253cec&scoped=true&lang=css"

import exportComponent from "/home/alfahuma/manual_build/digita-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31253cec"]])

export default __exports__